import { Component, OnInit } from '@angular/core';
import { SidenavItem } from '../sidenav/sidenav-item/sidenav-item.model';
import * as fromRoot from '../../reducers/index';
import * as fromSidenav from '../sidenav/shared/sidenav.action';
import { Store } from '@ngrx/store';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SetCurrentlyOpenByRouteAction } from '../sidenav/shared/sidenav.action';
import { SelectLayoutAction, SetCardElevationAction } from '../layout/shared/layout.action';

import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'vr-route-handler',
  templateUrl: './route-handler.component.html',
  styleUrls: ['./route-handler.component.scss']
})
export class RouteHandlerComponent implements OnInit {

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private route: ActivatedRoute,
    private i18n: I18n
  ) { }

  ngOnInit() {
    // Set Sidenav Currently Open on Page load
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.store.dispatch(new SetCurrentlyOpenByRouteAction(event.urlAfterRedirects));
      }
    });

    // You can use ?elevation=5 (anything from 0 to 24)
    this.route.queryParamMap.subscribe((params) => {
      this.store.dispatch(new SelectLayoutAction('alpha'));

      const elevation = params.get('elevation');

      if (elevation) {
        this.store.dispatch(new SetCardElevationAction('card-elevation-z' + elevation))
      }
    });

    // Top Level Item (The item to click on so the dropdown opens)
    const dashboard = new SidenavItem({
      name: this.i18n({value: 'Dashboard', id: 'Dashboard' }),
      route: '/',
      icon: 'dashboard',
      subItems: [ ],
      position: 1,
      routerLinkActiveOptions: {
        exact: true
      },
      action: 'dashboard'
    });

    // ENTERPRISES
    const enterprises = new SidenavItem({
      name: this.i18n({value: 'Enterprises', id: 'Enterprises' }),
      icon: 'store',
      route: null,
      subItems: [ ],
      position: 1,
      action: 'enterprises'
    });
    const enterprisesSubItems = [
      new SidenavItem({
        name: this.i18n({value: 'My Enterprise', id: 'MyEnterprise' }),
        icon: 'store',
        route: '/enterprises/mine',
        parent: enterprises,
        subItems: [ ],
        position: 1,
        action: 'getMyEnterprise'
      }),
      new SidenavItem({
        name: this.i18n({value: 'Enterprises', id: 'Enterprises' }),
        icon: 'store',
        route: '/enterprises',
        parent: enterprises,
        subItems: [ ],
        position: 1,
        action: 'getEnterprises'
      }),
      new SidenavItem({
        name: this.i18n({value: 'My Auditors', id: 'MyAuditors' }),
        icon: 'store',
        route: '/enterprises/auditors',
        parent: enterprises,
        subItems: [ ],
        position: 1,
        action: 'getEnterprisesAuditors'
      }),
      new SidenavItem({
        name: this.i18n({value: 'My Establishments', id: 'MyEstablishments' }),
        icon: 'store',
        route: '/enterprises/establishments',
        parent: enterprises,
        subItems: [ ],
        position: 1,
        action: 'getEnterprisesEstablishments'
      }),
      new SidenavItem({
        name: this.i18n({value: 'My Audited', id: 'MyAudited' }),
        icon: 'store',
        route: '/enterprises/audited',
        parent: enterprises,
        subItems: [ ],
        position: 1,
        action: 'getEnterprisesAudited'
      }),
      new SidenavItem({
        name: this.i18n({value: 'My Distributed', id: 'MyDistributed' }),
        icon: 'store',
        route: '/enterprises/distributed',
        parent: enterprises,
        subItems: [ ],
        position: 1,
        action: 'getEnterprisesDistributed'
      }),
    ];
    enterprises.subItems.push(...enterprisesSubItems);
    // ENTERPRISES END

    // FRAMES
    const frames = new SidenavItem({
      name: this.i18n({value: 'Frames', id: 'Frames' }),
      icon: 'assignment_turned_in',
      route: null,
      subItems: [ ],
      position: 1,
      action: 'frames'
    });
    const framesSubItems = [
      new SidenavItem({
        name: this.i18n({value: 'My Frames', id: 'MyFrames' }),
        icon: 'assignment_turned_in',
        route: '/frames',
        parent: frames,
        subItems: [ ],
        position: 1,
        action: 'frames'
      }),
      new SidenavItem({
        name: this.i18n({value: 'My Archived Frames', id: 'MyArchivedFrames' }),
        icon: 'assignment_turned_in',
        route: '/frames/archived',
        parent: frames,
        subItems: [ ],
        position: 1,
        action: 'archivedFrames'
      }),
      new SidenavItem({
        name: this.i18n({value: 'Frame\'s Catalog', id: 'FrameCatalog' }),
        icon: 'shopping_cart',
        route: '/frames/catalog',
        parent: frames,
        subItems: [ ],
        position: 1,
        action: 'catalogFrames'
      }),
    ];
    frames.subItems.push(...framesSubItems);
    // FRAMES END

    // AUDITS
    const audits = new SidenavItem({
      name: this.i18n({value: 'Audits', id: 'Audits' }),
      icon: 'assignment',
      route: null,
      subItems: [ ],
      position: 1,
      action: 'audits'
    });
    const auditPerformedItem = new SidenavItem({
      name: this.i18n({value: 'Performed Audits', id: 'PerformedAudit' }),
      icon: 'assignment',
      route: null,
      parent: audits,
      subItems: [],
      position: 1,
      action: 'auditsPerformed'
    });
    const auditInternalItem = new SidenavItem({
      name: this.i18n({value: 'Internal Audits', id: 'InternalAudit' }),
      icon: 'assignment',
      route: null,
      parent: audits,
      subItems: [],
      position: 1,
      action: 'auditsInternal'
    });
    const auditExternalSubItems = [
      // SubItem : Performed Audit > Draft
      new SidenavItem({
        name: this.i18n({value: 'Draft', id: 'PerformedDraftAudit' }),
        icon: 'assignment',
        route: '/audit/performed/draft',
        parent: auditPerformedItem,
        subItems: [],
        position: 1,
        action: 'auditsPerformedDraft'
      }),
      // SubItem : Performed Audit > Waiting
      new SidenavItem({
        name: this.i18n({value: 'Waiting Validation', id: 'PerformedWaitingAudit' }),
        icon: 'assignment',
        route: '/audit/performed/waiting',
        parent: auditPerformedItem,
        subItems: [],
        position: 1,
        action: 'auditsPerformedWaiting'
      }),
      // SubItem : Performed Audit > Validated
      new SidenavItem({
        name: this.i18n({value: 'Validated', id: 'PerformedValidatedAudit' }),
        icon: 'assignment_turned_in',
        route: '/audit/performed/validated',
        parent: auditPerformedItem,
        subItems: [],
        position: 1,
        action: 'auditsPerformedValidated'
      }),
    ];
    const auditInternalSubItems = [
      // SubItem : Internal Audit > Draft
      new SidenavItem({
        name: this.i18n({value: 'Draft', id: 'InternalDraftAudit' }),
        icon: 'assignment',
        route: '/audit/internal/draft',
        parent: auditInternalItem,
        subItems: [],
        position: 1,
        action: 'auditsInternalDraft'
      }),
      // SubItem : Internal Audit > Waiting
      new SidenavItem({
        name: this.i18n({value: 'Waiting Validation', id: 'InternalWaitingAudit' }),
        icon: 'assignment',
        route: '/audit/internal/waiting',
        parent: auditInternalItem,
        subItems: [],
        position: 1,
        action: 'auditsInternalWaiting'
      }),
      // SubItem : Internal Audit > Validated
      new SidenavItem({
        name: this.i18n({value: 'Validated', id: 'InternalValidatedAudit' }),
        icon: 'assignment_turned_in',
        route: '/audit/internal/validated',
        parent: auditInternalItem,
        subItems: [],
        position: 1,
        action: 'auditsInternalValidated'
      }),
    ];
    auditPerformedItem.subItems.push(...auditExternalSubItems);
    auditInternalItem.subItems.push(...auditInternalSubItems);
    audits.subItems.push(auditPerformedItem, auditInternalItem);
    // AUDITS END

    // ACTION PLANS
    const plans = new SidenavItem({
      name: this.i18n({value: 'Action Plans', id: 'Action Plans' }),
      icon: 'assignment_late',
      route: '/actions/plans',
      subItems: [ ],
      position: 1,
      action: 'plansScheduled'
    });
    // ACTION PLANS END

    // PLANNING PLANS
    const planning = new SidenavItem({
      name: this.i18n({value: 'Planning', id: 'Planning' }),
      icon: 'event',
      route: null,
      subItems: [ ],
      position: 1,
      action: 'planning'
    });
    const planningSubItems = [
      new SidenavItem({
        name: this.i18n({value: 'My Planning', id: 'MyPlanning' }),
        icon: 'event',
        route: '/planning',
        parent: planning,
        subItems: [ ],
        position: 1,
        action: 'myPlanning'
      }),
      new SidenavItem({
        name: this.i18n({value: 'My Enterprise', id: 'MyEnterprise' }),
        icon: 'event',
        route: '/planning/enterprise',
        parent: planning,
        subItems: [ ],
        position: 1,
        action: 'myEnterprisePlanning'
      }),
      new SidenavItem({
        name: this.i18n({value: 'Plan an Audit', id: 'PlanAudit' }),
        icon: 'event',
        route: '/planning/plan',
        parent: planning,
        subItems: [ ],
        position: 1,
        action: 'createPlanning'
      }),
      new SidenavItem({
        name: this.i18n({value: 'Plan an Audit', id: 'PlanAudit' }),
        icon: 'event',
        route: '/planning/schedulegroup',
        parent: planning,
        subItems: [ ],
        position: 1,
        action: 'createPlanningGroup'
      }),
    ];
    planning.subItems.push(...planningSubItems);
    // PLANNING PLANS

    // USERS
    const users = new SidenavItem({
      name: this.i18n({value: 'Users', id: 'Users' }),
      icon: 'group',
      route: null,
      subItems: [ ],
      position: 1,
      action: 'getAllUsers'
    });
    const usersSubItems = [
      new SidenavItem({
        name: this.i18n({value: 'Actived Users', id: 'ActivedUsers' }),
        icon: 'group',
        route: '/users',
        parent: users,
        subItems: [ ],
        position: 1,
        action: 'getAllUsers'
      }),
      new SidenavItem({
        name: this.i18n({value: 'Archived Users', id: 'ArchivedUsers' }),
        icon: 'group',
        route: '/users/archived',
        parent: users,
        subItems: [ ],
        position: 1,
        action: 'getArchivedUsers'
      })
    ];
    users.subItems.push(...usersSubItems);
    // USERS END

    const profile = new SidenavItem({
      name: this.i18n({value: 'Profile', id: 'Profile' }),
      icon: 'person',
      route: '/profile',
      subItems: [ ],
      position: 1,
      action: 'profile'
    });

    const inbox = new SidenavItem({
      name: 'Inbox',
      icon: 'mail',
      route: '/apps/inbox',
      subItems: [ ],
      position: 1
    });

    const chat = new SidenavItem({
      name: 'Chat',
      icon: 'message',
      route: '/apps/chat',
      subItems: [ ],
      position: 1
    });

    const forms = new SidenavItem({
      name: 'Forms',
      icon: 'assignment',
      route: null,
      subItems: [ ],
      position: 1
    });
    const formsSubItems = [
      new SidenavItem({
        name: 'Form Elements',
        route: '/forms/form-elements',
        parent: forms,
        subItems: [ ],
        position: 1
      }),

      new SidenavItem({
        name: 'Form Wizard',
        route: '/forms/form-wizard',
        parent: forms,
        subItems: [ ],
        position: 1
      })
    ];
    forms.subItems.push(...formsSubItems);

    const pages = new SidenavItem({
      name: 'Pages',
      icon: 'library_books',
      subItems: [ ],
      position: 1
    });
    const pagesSubItems = [
      new SidenavItem({
        name: this.i18n({value: 'Profile', id: 'Profile' }),
        route: '/pages/profile',
        parent: pages,
        subItems: [ ],
        position: 1,
        action: 'profile'
      }),
      new SidenavItem({
        name: 'Projects',
        route: '/pages/projects',
        parent: pages,
        subItems: [ ],
        position: 1
      }),
      new SidenavItem({
        name: 'Project Details',
        route: '/pages/project-details',
        parent: pages,
        subItems: [ ],
        position: 1
      }),
    ];
    pages.subItems.push(...pagesSubItems);

    const auth = new SidenavItem({
      name: 'Auth',
      icon: 'person_pin',
      route: null,
      subItems: [ ],
      position: 1
    });
    const authSubItems = [
      new SidenavItem({
        name: 'Login',
        route: '/auth/login',
        parent: auth,
        subItems: [ ],
        position: 1
      }),
      new SidenavItem({
        name: 'Forgot Password',
        route: '/auth/forgot-password',
        parent: auth,
        subItems: [ ],
        position: 1
      }),
    ];
    auth.subItems.push(...authSubItems);

    const components = new SidenavItem({
      name: 'Components',
      icon: 'layers',
      route: '/components',
      subItems: [ ],
      position: 1
    });

    const tables = new SidenavItem({
      name: 'Tables',
      icon: 'format_line_spacing',
      route: null,
      subItems: [ ],
      position: 1
    });
    const tablesSubItems = [
      new SidenavItem({
        name: 'Simple Table',
        route: '/tables/simple-table',
        parent: tables,
        subItems: [ ],
        position: 1
      }),
      new SidenavItem({
        name: 'Table Pagination',
        route: '/tables/table-pagination',
        parent: tables,
        subItems: [ ],
        position: 1
      }),
      new SidenavItem({
        name: 'Table Sorting',
        route: '/tables/table-sorting',
        parent: tables,
        subItems: [ ],
        position: 1
      }),
      new SidenavItem({
        name: 'Table Filtering',
        route: '/tables/table-filtering',
        parent: tables,
        subItems: [ ],
        position: 1
      }),
      new SidenavItem({
        name: 'Datatable',
        route: '/tables/datatable',
        parent: tables,
        subItems: [ ],
        position: 1
      }),
      new SidenavItem({
        name: 'All-In-One Table',
        route: '/tables/all-in-one-table',
        parent: tables,
        subItems: [ ],
        position: 1
      })
    ];
    tables.subItems.push(...tablesSubItems);

    const editor = new SidenavItem({
      name: 'Editor',
      icon: 'format_shapes',
      route: '/editor',
      subItems: [ ],
      position: 1
    });

    const dragAndDrop = new SidenavItem({
      name: 'Drag & Drop',
      icon: 'mouse',
      route: '/drag-and-drop',
      subItems: [ ],
      position: 1
    });

    const maps = new SidenavItem({
      name: 'Maps',
      icon: 'map',
      route: '/maps/google-maps',
      subItems: [ ],
      position: 1
    });

    const icons = new SidenavItem({
      name: 'Material Icons',
      icon: 'grade',
      route: '/material-icons',
      subItems: [ ],
      position: 1
    });

    // Send the created Menu structure to Redux/ngrx (you only need to send the Top Level Item, all dropdown items will be added automatically)
    // ERP
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(dashboard));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(enterprises));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(frames));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(audits));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(plans));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(planning));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(users));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(profile));

    // TEMPLATE
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(inbox));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(chat));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(forms));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(components));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(tables));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(editor));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(auth));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(pages));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(dragAndDrop));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(maps));
    this.store.dispatch(new fromSidenav.AddSidenavItemAction(icons));
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/route-handler/route-handler.component.ts